import { Input } from '../../ui/input/input';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { dialogActions } from '../slice/dialog-slice';
import './save-favorite-brand.scss';
import { apiActions } from '../../../slices/api-slice';
import { useAppSelector } from '../../../app/hooks';
import * as lodash from 'lodash';
import { favoriteBrandActions } from '../../../slices/favorite-brand-slice';
import { ResponseBase } from '../../../api/response-base';
import { FavoriteGetResponse } from '../../../models/api/front/favorite';
import { LoadingPopup } from '../../ui/loading/loading-popup';
import { FavoriteBrandConfigForPrint } from './favorite-brand-config-for-print';
import { ApiPrintFavoriteProductListGet } from '../../../api/sift/front/api-print-favorite-product-list-get';
import { ApiPrintFavoriteProductRegister } from '../../../api/sift/front/api-print-favorite-product-register';
import { PrintProductDataEntity } from '../../../models/sift/json/print-model';

export const SaveFavoriteBrandForPrint = (props: { kijshopCd: string, productData?: PrintProductDataEntity }) => {
  const { kijshopCd, productData } = props;
  // - Hooks -
  const dispatch = useDispatch();
  const { selectBrand } = useAppSelector((state) => ({
    selectBrand: state.favoriteBrand.selectBrand,
  }), lodash.isEqual);
  // - State -
  // -- 名称 --
  const [name, setName] = useState('');
  const [registering, setRegistering] = useState(false);
  // - Callback -
  // -- 名称更新 --
  const handlerChangeName = useCallback((v) => {
    setName(v);
  }, []);
  // -- OKボタン押下 --
  const handlerClickOk = useCallback(() => {
    if (!selectBrand || !productData) {
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: ['商品情報の取得に失敗しました'],
        buttons: [{
          label: 'OK',
          callback: () => {
            dispatch(dialogActions.pop());
          },
        }],
      }));
      return;
    }
    if (!name) {
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: [
          'お気に入り商品名称を入力してください。',
        ],
        buttons: [
          {
            label: 'OK',
            callback: () => {
              dispatch(dialogActions.pop());
            },
          },
        ],
      }));
    } else {
      setRegistering(true);
      const folderId = selectBrand?.type === 'brand' ? selectBrand.parentId : selectBrand.id;
      dispatch(apiActions.run(
        new ApiPrintFavoriteProductListGet({ kijshopCd, folderId: folderId }),
        {
          onSuccess: async (res: ResponseBase<FavoriteGetResponse>) => {
            if (res?.body?.data?.favProductList?.find((v) => v.name === name)) {
              setRegistering(false);
              dispatch(dialogActions.pushMessage({
                title: '確認',
                message: [
                  '入力されたお気に入り商品名称は既に存在します。',
                  '別のお気に入り商品名称を入力してください。',
                ],
                buttons: [
                  {
                    label: 'OK',
                    callback: () => {
                      dispatch(dialogActions.pop());
                    },
                  },
                ],
              }));
            } else {
              dispatch(apiActions.run(
                new ApiPrintFavoriteProductRegister(
                  {
                    kijshopCd,
                    folderId,
                    name,
                    level: selectBrand.level,
                    indexes: 0,
                    json: [{
                      filename: 'favorite.json',
                      body: JSON.stringify(productData),
                    }],
                  },
                ),
                {
                  onSuccess: () => {
                    setRegistering(false);
                    dispatch(dialogActions.pop());
                    dispatch(dialogActions.pushMessage({
                      title: '確認',
                      message: ['登録が完了しました'],
                      buttons: [{
                        label: 'OK',
                        callback: () => {
                          dispatch(dialogActions.pop());
                        },
                      }],
                    }));
                  },
                  onError: () => {
                    setRegistering(false);
                    dispatch(dialogActions.pushMessage({
                      title: '確認',
                      message: ['お気に入り商品の登録に失敗しました'],
                      buttons: [{
                        label: 'OK',
                        callback: () => {
                          dispatch(dialogActions.pop());
                        },
                      }],
                    }));
                  },
                }
              ));
            }
          },
          onError: () => {
            setRegistering(false);
            dispatch(dialogActions.pushMessage({
              title: '確認',
              message: ['お気に入り商品の登録に失敗しました'],
              buttons: [{
                label: 'OK',
                callback: () => {
                  dispatch(dialogActions.pop());
                },
              }],
            }));
          },
        },
      ));
    }
  }, [name, selectBrand]);
  // -- キャンセルボタン押下 --
  const handlerClickCancel = useCallback(() => {
    dispatch(dialogActions.pop());
    dispatch(favoriteBrandActions.setSelectBrand(undefined));
  }, []);
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, []);
  return (
    <div className="dialog_contents save_favorite_brand">
      <div className="dialog_contents__body">
        <div className="save_favorite_brand__top">
          <span>登録する事で、次回から簡単に呼び出せます。</span>
          <span>①お気に入り保存する名称を入力してください</span>
          <Input
            ref={ref}
            value={name}
            onChange={(e) => handlerChangeName(e.target.value)}
            maxLength={40}
          />
          <span className="emphasis_red">※ 40文字以内で入力してください</span>
        </div>
        <div className="save_favorite_brand__bottom">
          <span>②保存先フォルダを選択してください</span>
          <FavoriteBrandConfigForPrint
            closeButtonLabel='キャンセル'
            closeButtonCallback={handlerClickCancel}
            okButtonCallback={handlerClickOk}
            isSaveDialog={true}
            kijshopCd={kijshopCd}
            disabled={!name}
          />
        </div>
      </div>
      {registering ? (<LoadingPopup label="商品情報を登録中です..." />) : (<></>)}
    </div>
  );
};
